// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5299":"c45dc433","6136":"c45dc433"}[chunkId] + ".chunk.css";
};